
define('tmpl!core/templates/webidl-contiguous/maplike.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlMaplike\' id="{{obj.idlId}}" data-idl data-title=\'maplike\'>{{extAttr obj indent\n}}{{idn indent}}{{qualifiers}}{{#tryLink obj}}maplike{{/tryLink\n}}&lt;{{idlType obj}}&gt;;</span>\n');});

